import firebase from "../firebase";

export default function({ officeId, personId, roomId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "pagingUser",
        funcName: "unpagePersonFromRoom",
        data: { officeId, personId, roomId }
    });
}
